import { Transition } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { FunctionComponent } from 'react';
import './PageProgressLine.scss';

export interface IPageProgressLineProps {
  isHighlighted: boolean;
  className?: string | object;
}

const PageProgressLine: FunctionComponent<IPageProgressLineProps> = (props) => {
  const { isHighlighted, className } = props;

  const classes = classNames(
    {
      'page-progress-line': true,
    },
    className
  );

  const progressClasses = classNames({
    'highlighted': isHighlighted,
    'progress-line': true,
  });

  return (
    <div className={classes}>
      <Transition isOpen={isHighlighted} transitionName="horizontal-grow" speedIn={600} speedOut={800}>
        <div className={progressClasses} />
      </Transition>
    </div>
  );
};

export default PageProgressLine;
